module.exports = __webpack_public_path__ + "static/media/table_compare.4ca597cc.png";